module.exports = __webpack_public_path__ + "static/media/GroupRightSideExamSuggestHomePage.18b3872a.svg";